// File: components/AdditionalCosts.js
import React, { useState } from 'react';

const AdditionalCosts = ({
  legalCosts, setLegalCosts,
  travelCosts, setTravelCosts,
  additionalCosts, setAdditionalCosts,
  additionalCostsInfo
}) => {
  const [showInfo, setShowInfo] = useState(false);

  return (
    <div className="mb-6">
      <h2 className="text-xl font-semibold mb-2 flex items-center">
        {additionalCostsInfo.title}
        <button
          className="ml-2 text-blue-500 text-sm"
          onClick={() => setShowInfo(!showInfo)}
        >
          {showInfo ? additionalCostsInfo.hideInfoLabel : additionalCostsInfo.showInfoLabel}
        </button>
      </h2>

      {showInfo && (
        <div className="bg-blue-50 p-3 rounded mb-3 text-sm">
          <h3 className="font-medium mb-1">{additionalCostsInfo.aboutTitle}</h3>
          <p className="mb-2">{additionalCostsInfo.mainDescription}</p>

          <ul className="list-disc pl-5">
            <li><strong>{additionalCostsInfo.legalTitle}</strong> {additionalCostsInfo.legalFullDescription}</li>
            <li><strong>{additionalCostsInfo.travelTitle}</strong> {additionalCostsInfo.travelFullDescription}</li>
            <li><strong>{additionalCostsInfo.additionalTitle}</strong> {additionalCostsInfo.additionalFullDescription}</li>
          </ul>
        </div>
      )}

      <div className="mb-3">
        <label className="block mb-1">{additionalCostsInfo.legalLabel}</label>
        <input
          type="number"
          value={legalCosts}
          onChange={(e) => setLegalCosts(Number(e.target.value))}
          className="w-full p-2 border rounded"
          min="0"
          placeholder={additionalCostsInfo.legalPlaceholder}
        />
        <p className="text-xs text-gray-500 mt-1">{additionalCostsInfo.legalDescription}</p>
      </div>

      <div className="mb-3">
        <label className="block mb-1">{additionalCostsInfo.travelLabel}</label>
        <input
          type="number"
          value={travelCosts}
          onChange={(e) => setTravelCosts(Number(e.target.value))}
          className="w-full p-2 border rounded"
          min="0"
          placeholder={additionalCostsInfo.travelPlaceholder}
        />
        <p className="text-xs text-gray-500 mt-1">{additionalCostsInfo.travelDescription}</p>
      </div>

      <div className="mb-3">
        <label className="block mb-1">{additionalCostsInfo.additionalLabel}</label>
        <input
          type="number"
          value={additionalCosts}
          onChange={(e) => setAdditionalCosts(Number(e.target.value))}
          className="w-full p-2 border rounded"
          min="0"
          placeholder={additionalCostsInfo.additionalPlaceholder}
        />
        <p className="text-xs text-gray-500 mt-1">{additionalCostsInfo.miscDescription}</p>
      </div>
    </div>
  );
};

export default AdditionalCosts;